import React from "react";
import { About } from "../common";

export const AboutMinimumLatency = (props) => {
  return (
    <>
      <div className={props.className}>
        <About id='about-latency'>
          Global minimum latency is the minimum (fastest) latency of all latency measurements to all locations.
        </About>
      </div>
    </>
  );
};
